/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'globe': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M28.28 20.269A13.022 13.022 0 0116.005 29l-.006.005-.005-.005a13.021 13.021 0 01-12.272-8.725 13 13 0 01.044-8.675A13.022 13.022 0 0115.995 3L16 2.995l.005.005a13.022 13.022 0 0112.273 8.728 13 13 0 01.001 8.54zM19.19 11A13.802 13.802 0 0016 5.695 13.802 13.802 0 0012.81 11h6.38zM16 26.305A13.802 13.802 0 0019.19 21h-6.38A13.802 13.802 0 0016 26.305zM12.286 13a15.866 15.866 0 000 6h7.428a15.866 15.866 0 000-6h-7.428zm14.298 0h-4.83a18.383 18.383 0 010 6h4.83a11.03 11.03 0 000-6zm-5.283-2h4.496a11.04 11.04 0 00-7.513-5.76A15.932 15.932 0 0121.301 11zm0 10a15.93 15.93 0 01-3.017 5.76A11.04 11.04 0 0025.797 21H21.3z" _fill="#0B2C62"/>'
  }
})
